<template>
  <a-card :bordered="false">

    <!-- 操作按钮区域 -->
    <div class="table-operator" style="margin-bottom:20px;" v-if="permissions.includes('back:menu:add')">
      <a-button @click="handleAdd" type="primary" icon="plus">新增</a-button>
    </div>

    <!-- table区域-begin -->
    <div>
      <a-table
        bordered
        rowKey="id"
        :columns="columns"
        :pagination="false"
        :dataSource="dataSource"
        :loading="loading">
        <span slot="ico" slot-scope="text">
          <i class="iconfont" :class="text"></i>
        </span>
        <span slot="action" slot-scope="text, record">
          <a @click="handleEdit(record)" v-if="permissions.includes('back:menu:update')">编辑</a>

          <a-divider type="vertical"/>
          <a-dropdown>
            <a class="ant-dropdown-link">
              更多 <a-icon type="down"/>
            </a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a href="javascript:;" @click="handleDetail(record)">详情</a>
              </a-menu-item>
              <a-menu-item v-if="permissions.includes('back:menu:delete')">
                <a-popconfirm title="确定删除吗?" @confirm="() => handleRemove(record.id)" okText="确定" cancelText="取消">
                  <a>删除</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>
        <span slot="enable" slot-scope="text" :class="text ? '' : 'state' ">
          {{ text ? '启用' : '禁用' }}
        </span>
      </a-table>

    </div>
    <!-- table区域-end -->

    <permission-modal ref="modalForm" @ok="modalFormOk"></permission-modal>

  </a-card>
</template>

<script>
import PermissionModal from './modules/PermissionModal'
import { getPermissionTree, removePermission } from '@/baseAPI/memuSetting'
import { mapState } from 'vuex'
const columns = [
  {
    title: '菜单名称',
    dataIndex: 'name',
    key: 'name'
  },
  {
    title: '图标',
    dataIndex: 'ico',
    key: 'ico',
    align: 'center',
    scopedSlots: { customRender: 'ico' },
  },
  {
    title: '备注',
    dataIndex: 'description',
    key: 'description'
  },
  {
    title: '路径',
    dataIndex: 'url',
    key: 'url'
  },
  {
    title: '排序',
    dataIndex: 'orderCode',
    key: 'orderCode'
  },
  {
    title: '状态',
    dataIndex: 'enable',
    key: 'enable',
    scopedSlots: { customRender: 'enable' }
  },
  {
    title: '操作',
    dataIndex: 'action',
    scopedSlots: { customRender: 'action' },
    align: 'center',
    width: 150
  }
]

export default {
  name: 'memuSetting',
  components: {
    PermissionModal
  },
  computed: {
    ...mapState({
      permissions: state => state.user.permissions
    })
  },
  data () {
    return {
      description: '这是菜单管理页面',
      // 表头
      columns: columns,
      loading: false,
      dataSource: [],
      treeData: []
    }
  },
  mounted () {
    this.loadData()
  },
  methods: {
    loadData () {
      return getPermissionTree()
        .then(res => {
          this.dataSource = res.data
          this.treeData = res.data
        })
    },
    handleDetail: function (record) {
      this.$refs.modalForm.edit(record, this.treeData)
      this.$refs.modalForm.title = '详情'
      this.$refs.modalForm.disableSubmit = true
    },
    handleEdit: function (record) {
      this.$refs.modalForm.edit(record, this.treeData)
      this.$refs.modalForm.title = '编辑'
    },
    handleAdd: function () {
      this.$refs.modalForm.add(this.treeData)
      this.$refs.modalForm.title = '新增'
    },
    handleRemove (id) {
      removePermission(id).then((res) => {
        this.$notification.success({
          message: '提示',
          description: res.message || '删除菜单权限成功',
          duration: 3
        })
        this.loadData()
      }).catch(err => {
        this.$notification.error({
          message: '错误',
          description: ((err.response || {}).data || {}).message || '删除菜单权限失败',
          duration: 3
        })
      })
    },
    modalFormOk () {
      // 新增/修改 成功时，重载列表
      this.loadData()
    }
  }
}
</script>
<style scoped>
  a{
    display: inline-block;
    text-decoration: none;
    color: #1F5EFF;
  }
  .state{
    color: red;
  }
</style>
